import { createSlice, PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';
import { ExpandedRowPrice } from '../../../../@types';
import { RootState } from '../../../../@types/RootState';

export type ExpandedRowOfferState = ExpandedRowPrice | null;

export type UpdateExpandedRowOfferPayload = Partial<ExpandedRowOfferState>;

const initialState: ExpandedRowOfferState = null;

const slice = createSlice<ExpandedRowOfferState, SliceCaseReducers<ExpandedRowOfferState>>({
  name: 'ipa.priceManager.expandedRow.offer',
  initialState,
  reducers: {
    reset: () => initialState,
    set: (_s, action: PayloadAction<ExpandedRowOfferState>) => action.payload,
    update: (state, action: PayloadAction<UpdateExpandedRowOfferPayload>) => {
      if (state) return Object.assign(state, action.payload);
      return state;
    },
  },
});

export const { reset, set, update } = slice.actions;

export const selectorExpandedRowOffer = (state: RootState) => {
  return state.ipa.priceManager.expandedRow.offer;
};

export default slice.reducer;
